import { memo } from 'react';

import { BUSINESS_TOOL_SECTIONS, IBusinessToolSections } from 'constants/businessTool';

import { SectionChangeObserver } from '../SectionChangeObserver';

export const FormChangeObserver = memo(() => {
  return (
    <>
      {Object.values(BUSINESS_TOOL_SECTIONS).map((sectionName) => (
        <SectionChangeObserver key={sectionName} chapterName={sectionName as IBusinessToolSections} />
      ))}
    </>
  );
});
